// import 'select2/dist/css/select2.min.css'
// import 'select2/dist/js/select2.min.js'

export default class Select2 {
  static init() {
    // window.jQuery('#shipping_neighborhood').select2()
  }
}
